import { Cancel } from '@mui/icons-material';
import AccordinButton from "components/AccordinButton";
import ResizeAndDragabble from "components/ResizeAndDraggable";
import { find, get } from "lodash";
import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useCurrentUser } from "store/users/selectors";
import { confirmUnshareWidget } from "store/widgets/confirmUnshare";
import { revokeTrafficModal } from "store/wheel/actions";
import { useTraffic } from "store/wheel/selectors";
import styled from "styled-components";
import ReminderWidgetStudent from './reminder/ReminderWidgetStudent';
import ReminderWidgetTeacher from './reminder/ReminderWidgetTeacher';
import { useClassUsers } from "store/userClasses/selectors";
import SentryWrap from 'components/Sentry';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 0px;
  z-index: 99999999;
  position: fixed;
  cursor: grab;
  transform: translate(31%, 0%);

  @media (max-width: 1450px) {
    transform: translate(0%, 0%);
  }
  @media (max-width: 992px) {
    transform: translate(0%, 0%);
  }
`;

const DragHandle = styled.div`
  touch-action: none;
`;

const WidgetsReminder = ({ currentClass, sharableWidget }) => {
  const [showAccordin, setShowAccordin] = useState(true);
  const [dimensions, setDimensions] = useState({});
  const dispatch = useDispatch();
  const [trafficModal] = useTraffic();
  const currentUser = useCurrentUser();
  const isTeacher = get(currentUser, "role") === "teacher";
  const classUser = useClassUsers();

  const studentsForReminder = useMemo(() => {
    const activeStudents = Array.isArray(classUser)
      ? classUser.filter((k) => k?.userclass?.active && k?.active !== false && k.role === 'student')
      : [];
    return activeStudents.map((u) => ({
      id: u.id,
      name: [get(u, 'firstName', ''), get(u, 'lastName', '')].filter(Boolean).join(' ') || get(u, 'username', u.id),
      email: u.email,
      active: u.active,
    }));
  }, [classUser]);

  const trafficData = trafficModal?.widget_menu ?? [];
  const filterByWidget = find(
    trafficData,
    (item) => item?.menu === "widget_reminder"
  );
  const filterShareReminder = find(sharableWidget, (obj) => obj?.widget_type === 'widget_reminder');

  const onClose = async () => {
    const shouldClose = await confirmUnshareWidget({
      isShared: filterShareReminder?.status,
      widgetName: "Reminder widget",
    });
    if (!shouldClose) return;
    await dispatch(revokeTrafficModal(filterByWidget?.id));
  };

  const handleTouchClose = (event) => {
    event.preventDefault();
    onClose();
  };

  return (
    <SentryWrap>
      {((filterByWidget?.view && filterByWidget?.menu === "widget_reminder") || filterShareReminder?.id) && (
        <Container className="allCheckListSEction wigetsContainer">
          <div className="mainCheckList">
            <ResizeAndDragabble
              defaultValue={{
                x: 150,
                y: 205,
                width: 400,
                height: 420,
              }}
              resize={(data) => setDimensions(data)}
              showAccordin={showAccordin}
              dragHandleClassName="reminder-widget-drag-handle"
            >
              <div
                className="checkListTopSection"
                style={{
                  position: "relative",
                  boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px",
                  width: "100%",
                  height: showAccordin ? "100%" : "0px",
                  padding: "0px",
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  boxSizing: "border-box",
                }}
              >
                <DragHandle className="mainTimerShareBtn reminder-widget-drag-handle" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0, }}>
                  <div
                    className={`checkListFirstTxt widgetFooterGradientOrange w-full bg-blue-10 pt-17px pb-14px ${
                      showAccordin ? "br-topLeft-topRight-20px" : "br-20px"
                    } `}
                  >
                    <AccordinButton open={showAccordin} onClose={() => setShowAccordin(prev => !prev)} />
                    <span className="text-white text-ft12-700">Reminders</span>
                  </div>
                  <div className="timerCancelBtn" style={{ display: "flex", position: "absolute", right: "10px", top: "13px" }}>
                    {isTeacher && (
                      <Cancel
                        onClick={() => onClose()}
                        onTouchStart={handleTouchClose}
                        style={{
                          marginLeft: "5px",
                          right: 7,
                          top: 16,
                          fontSize: 18,
                          color: "red",
                          background: "white",
                          borderRadius: 20,
                          cursor: 'pointer'
                        }}
                      />
                    )}
                  </div>
                </DragHandle>
                <div
                  style={{
                    display: showAccordin ? "flex" : "none",
                    flex: 1,
                    minHeight: 0,
                    flexDirection: "column",
                    overflow: "hidden",
                  }}
                >
                  {isTeacher ? (
                    <ReminderWidgetTeacher
                      classId={get(currentClass, 'id', '')}
                      teacherId={get(currentUser, 'id', '')}
                      students={studentsForReminder}
                    />
                  ) : (
                    <ReminderWidgetStudent
                      classId={get(currentClass, 'id', '')}
                      studentId={get(currentUser, 'id', '')}
                    />
                  )}
                </div>
              </div>
            </ResizeAndDragabble>
          </div>
        </Container>
      )}
    </SentryWrap>
  );
};

export default React.memo(WidgetsReminder);
